import * as React from "react";
import {faCaretDown}                from "@fortawesome/free-solid-svg-icons";
import {faCaretUp}                  from "@fortawesome/free-solid-svg-icons";
import {faClose}                    from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {AnalyticsLeadCard}          from "./analytics-lead-card/analytics-lead-card";
import {AnalyticsActions}           from "./analytics-actions/analytics-actions";
import {Pagination}                 from "./pagination/pagination";
import {xdQAAttribute}              from "../analytics-layout";

import "./analytics-leads.scss";

const PAGE_SIZES = [5, 10, 20]

const messageAdvancedSearch = `Utilize the advanced search feature to refine your search outcome`

export const AnalyticsLeads = ({
    leadInteractions,
    acceptLeads,
    setShowAdvancedSearch,
    setLeadInfo,
    createMailingList,
    addressListMessage, setAddressListMessage,
    addressListLeadsExcluded, setAddressListLeadsExcluded,
    addressListLeadsIncluded, setAddressListLeadsIncluded,
    filters, setFilters,
    leadsSelected, setLeadsSelected,
    startDate, setStartDate,
    endDate, setEndDate,
    pageIndex, setPageIndex
}) => {
    const [sortValue, setSortValue] = React.useState(leadColumns[1].interactionKey)
    const [ascending, setAscending] = React.useState(true)
    const [displayedCount, setDisplayedCount] = React.useState(PAGE_SIZES[0])
    const [showActions, setShowActions] = React.useState(false)

    const showFilterChips = (filters?.length > 0 || startDate || endDate)

    const removeFilter = (filterIndex, valueIndex) => {
        const tempFilters = [...filters]
        tempFilters[filterIndex].values.splice(valueIndex, 1)
        if(tempFilters[filterIndex].values.length === 0) {
            tempFilters.splice(filterIndex, 1)
        }
        setFilters(tempFilters)
    }

    const sumFilters = () => {
        if(filters.length === 0) {
            return 0
        }
        let sum = 0
        filters.forEach(filter => {
            sum += filter.values.length
        })
        return sum
    }

    const leadInteractionsSorted = () => {
        const ascendingMultiplier = ascending ? 1 : -1
        return (
            leadInteractions.sort((a, b) => {
                let first = a[sortValue]
                let second = b[sortValue]
                if(sortValue === 'date') {
                    first = new Date(a[sortValue])
                    second = new Date(b[sortValue])
                }

                if(sortValue === 'name') {
                    first = a[sortValue].toString().trim().toLowerCase()
                    second = b[sortValue].toString().trim().toLowerCase()
                }

                if(first > second) {
                    return -1 * ascendingMultiplier
                }
                if(first < second) {
                    return ascendingMultiplier
                }
                return 0
            })
        )
    }

    const leadInteractionsVisible = () => {
        return (
            leadInteractionsSorted().filter((interaction, i) => {
                return (!(i < (displayedCount * pageIndex)) && i < (displayedCount * (pageIndex + 1)))
            })
        )
    }

    const leadInteractionsSelected = () => {
        return (
            leadInteractionsSorted().filter(interaction => {
                return leadsSelected.includes(interaction?.idLead)
            })
        )
    }

    return (
        <div className="analytics-leads">
            <div className="analytics-header">
                <div className="analytics-message">
                    <h5
                        className="analytics-title"
                        {...xdQAAttribute('label', 'lead table title')}
                    >
                        Leads
                    </h5>
                    <p
                        className="analytics-text"
                        {...xdQAAttribute('label', 'lead search subtitle')}
                    >
                        {messageAdvancedSearch}
                    </p>
                </div>
            </div>
            <div className='anayltics-list' >
                <div className="filter-header">
                    <div className="filter-container">
                        <div className={`filter-active ${showFilterChips ? 'expanded' : 'collapsed'}`} />
                        <AnalyticsActions
                            {...{
                                acceptLeads,
                                leadInteractionsSelected,
                                createMailingList,
                                setAddressListLeadsIncluded,
                                addressListMessage, setAddressListMessage,
                                addressListLeadsExcluded, setAddressListLeadsExcluded,
                                leadsSelected, setLeadsSelected,
                                showActions, setShowActions
                            }}
                        />
                    </div>
                </div>
                {
                    leadInteractions.length > 0
                    ?   <>
                            <div className="analytics-list-header">
                                <div className="analytics-list-select-all" >
                                    <input
                                        className={`checkbox-all ${leadsSelected.length > 0 ? 'selected' : ''}`}
                                        type="checkbox"
                                        checked={leadsSelected.length > 0}
                                        onChange={() => {
                                            const selected = leadsSelected.length > 0
                                            ? leadsSelected.filter(interactionKey => interactionKey === null)
                                            : leadInteractions.map(interaction => interaction?.idLead)
                                            setLeadsSelected([...selected])
                                        }}
                                        {...xdQAAttribute('checkbox', 'select all leads')}
                                    />
                                </div>
                                {
                                    leadColumns.map(column => {
                                        return (
                                            <div
                                                className="column"
                                                key={column.interactionKey}
                                                onClick={() => {
                                                    const ascendingToggle = sortValue !== column.interactionKey
                                                    ? true : !ascending

                                                    setSortValue(column.interactionKey)
                                                    setAscending(ascendingToggle)
                                                }}
                                                {...xdQAAttribute('text', column.interactionKey)}
                                            >
                                                {column.headerText}
                                                <FontAwesomeIcon
                                                    className={`icon ${sortValue === column.interactionKey ? 'selected' : ''}`}
                                                    icon={(sortValue === column.interactionKey && !ascending)
                                                            ? faCaretUp
                                                            : faCaretDown
                                                    }
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <hr />
                            {
                                leadInteractionsVisible().map((interaction, i) => {
                                    return (
                                        <AnalyticsLeadCard
                                            key={interaction.idLead}
                                            modulus={i % 2}
                                            {...{
                                                acceptLeads,
                                                interaction,
                                                setLeadInfo,
                                                leadsSelected, setLeadsSelected
                                            }}
                                        />
                                    )
                                })
                            }
                            <hr />
                        </>
                    :   <div className="filtered-out">
                            <p>No leads found</p>
                        </div>
                }
            </div>
            <Pagination
                rows={leadInteractionsSorted()}
                pageSizes={PAGE_SIZES}
                {...{
                    displayedCount, setDisplayedCount,
                    pageIndex, setPageIndex
                }}
            />
        </div>
    )
}

const FilterChip = ({filter, index, removeFilter}) => {
    const filterValues = filter.values
    return (
        <React.Fragment key={index}>
            {
                filterValues.map((value, j) => {
                    return (
                        <div
                            className="filter-value"
                            key={j}
                            {...xdQAAttribute('badge', filter.filterKey)}
                        >
                            <p>{value}</p>
                            <FontAwesomeIcon
                                className="icon"
                                icon={faClose}
                                onClick={() => removeFilter(index, j)}
                                {...xdQAAttribute('icon', `remove filter ${value}`)}
                            />
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export const leadColumns = [
    {
        headerText: 'NAME',
        interactionKey: 'name'
    },
    {
        headerText: 'LAST INTERACTION',
        interactionKey: 'date'
    },
    {
        headerText: 'QR CODE',
        interactionKey: 'qr'
    },
    {
        headerText: 'INFORMED DELIVERY',
        interactionKey: 'informedDelivery'
    },
    {
        headerText: 'CONTACT FORM SUBMISSION',
        interactionKey: 'formSubmission'
    },
    {
        headerText: 'HOME VALUE FORM SUBMISSION',
        interactionKey: 'homeValueForm'
    }
]